import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { ModalitaAssistenzaCasse } from '@app/shared/models/assistenza';
import { UtilityService } from '@app/shared/services/utility.service';

@Component({
  selector: 'ser-modalita-assistenza-casse-select',
  templateUrl: './modalita-assistenza-casse-select.component.html',
  styleUrl: './modalita-assistenza-casse-select.component.scss'
})
export class ModalitaAssistenzaCasseSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() label: string = "assistenze.fields.modalitaCasse";
  @Input() readonly: boolean = false;

  tipi: IS1InputSelectItem[];

  constructor(private utils: UtilityService) {
    this.tipi = this.utils.getInputSelectFromEnum(ModalitaAssistenzaCasse);
  }

}
